import config from "../../config";

// Same auth pattern as the app controllers (note the double space — matches authHeader).
function authHeader() {
  const user = JSON.parse(localStorage.getItem("user"));
  if (user && user.key) {
    return { Authorization: "Token  " + user.key };
  }
  return {};
}

async function req(path, { method = "GET", body } = {}) {
  const headers = Object.assign({ "Content-Type": "application/json" }, authHeader());
  const request = new Request(`${config.apiGateway.URL}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  const response = await fetch(request);
  let json = null;
  try {
    json = await response.json();
  } catch (e) {
    json = null;
  }
  return { json, status: response.status };
}

// Offices the caller may manage users for (admin-scoped; drives the office selector).
export const getAdministeredOffices = () => req(`/clinics/administered-offices/`);

export const getOfficeUsers = (officeId) => req(`/clinics/office/${officeId}/users/`);

export const createOfficeUser = (officeId, email, password) =>
  req(`/clinics/office/${officeId}/users/`, { method: "POST", body: { email, password } });

export const inviteOfficeUser = (officeId, email) =>
  req(`/clinics/office/${officeId}/users/invite/`, { method: "POST", body: { email } });

export const setOfficeUserPassword = (officeId, userId, password) =>
  req(`/clinics/office/${officeId}/users/${userId}/set-password/`, {
    method: "POST",
    body: { password },
  });

export const removeOfficeUser = (officeId, userId) =>
  req(`/clinics/office/${officeId}/users/${userId}/remove/`, { method: "POST" });
